import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";

/**
 * read-only view of the company master data. the values are maintained outside
 * this app, so they render as plain label-value pairs instead of disabled
 * inputs that look like an editable form
 */
const CompanyFormComponent:React.FC=()=>{
  const {
    services: {
      serviceAuth
    },
    I18N
  } = useContext(AppContext);

  /**
   * state variables
   */
  const [partner, setPartner] = useState<any>({
    name: "",
    name2: "",
    vatid: "",
    street: "",
    housenumber: "",
    city: "",
    zip: "",
    country: "",
    www: "",
    gln: "",
    duns: ""
  });

  useEffect(() => {
    let _user = serviceAuth.getUser();
    if (_user) {
      // @ts-ignore
      setPartner(_user.partner);
    }
  }, [serviceAuth]);

  /**
   * countryName
   * resolves the stored country code to its translated display name; the raw
   * code is data, not something a reader should have to decode
   */
  const countryName = (code: string): string => {
    switch (code) {
      case "DE": return I18N.t("Deutschland");
      case "NL": return I18N.t("Niederlande");
      case "UK": return I18N.t("England");
      default: return code || "";
    }
  };

  /**
   * fact
   * one label-value pair; an empty value renders as an em dash so the reader
   * sees "no value" instead of a hole
   */
  const fact = (label: string, value: string | undefined) => (
    <div data-fact>
      <span data-fact-label>{ label }</span>
      <span data-fact-value>{ value || "—" }</span>
    </div>
  );

  return(
    <div data-fact-sheet>
      { fact(I18N.t("Firma"), partner?.name) }
      { fact(I18N.t("Name 2"), partner?.name2) }
      { fact(I18N.t("Umsatzsteueridentifikationsnummer (USt-IdNr.)"), partner?.vatid) }
      { fact(I18N.t("Straße"), partner?.street) }
      { fact(I18N.t("Hausnummer"), partner?.housenumber) }
      { fact(I18N.t("Stadt"), partner?.city) }
      { fact(I18N.t("Postleitzahl"), partner?.zip) }
      { fact(I18N.t("Adresszusatz"), "") }
      { fact(I18N.t("Land"), countryName(partner?.country)) }

      <h3>{I18N.t("Zusätzliche Angaben")}</h3>

      { fact(I18N.t("Webseite (optional)"), partner?.www) }
      { fact(I18N.t("GTIN"), partner?.gln) }
      { fact(I18N.t("DUNS"), partner?.duns) }
    </div>
  );
};

export default CompanyFormComponent;
